import { Minus, Plus } from '../../icons';
import { tTravel } from './lib/travelI18n';
import './MapControls.css';

const MIN_LEVEL = 1;
const MAX_LEVEL = 14;

/**
 * 지도 오른쪽 위 +/− 단추. 카카오 지도는 레벨 숫자가 작을수록 가깝다.
 * ⚠ `setLevel` 에 animate 를 주지 않는다 — 도는 동안 `getLevel` 이 옛 값이라 연타가 한 단계로 뭉친다.
 * ⚠ 카카오 `ZoomControl` 을 쓰지 않는다 — 눈금 막대가 붙어 110px 미리보기에 다 안 들어가고,
 *   키보드로 닿지 않는다. 작성 화면은 `<form>` 안이라 `type="button"` 이 꼭 있어야 한다.
 */
export function MapZoomButtons({ map }: { map: any }) {
  const zoomBy = (delta: number) => {
    map.setLevel(Math.min(MAX_LEVEL, Math.max(MIN_LEVEL, map.getLevel() + delta)));
  };

  return (
    <div className="calendar-map-zoom">
      <button type="button" aria-label={tTravel('map_zoom_in')} onClick={() => zoomBy(-1)}>
        <Plus size={14} aria-hidden />
      </button>
      <button type="button" aria-label={tTravel('map_zoom_out')} onClick={() => zoomBy(1)}>
        <Minus size={14} aria-hidden />
      </button>
    </div>
  );
}
